export const ACCESS_DENIED = 'ACCESS_DENIED';
export const SUSPENDED_SCHOOL = 'SUSPENDED_SCHOOL';
export const UNVERIFIED_EMAIL = 'UNVERIFIED_EMAIL';
export const DEACTIVATED_ACCOUNT = 'DEACTIVATED_ACCOUNT';
export const SCHOOL_WAS_DEACTIVATED = 'SCHOOL_WAS_DEACTIVATED';
export const EMAIL_VERIFICATION_TOKEN_EXPIRED = 'EMAIL_VERIFICATION_TOKEN_EXPIRED';
export const VALID_EMAIL_VERIFICATION_TOKEN_EXISTS = 'VALID_EMAIL_VERIFICATION_TOKEN_EXISTS';
export const EMAIL_VERIFICATION_TOKEN_DOES_NOT_EXIST = 'EMAIL_VERIFICATION_TOKEN_DOES_NOT_EXIST';


// WEBPACK FOOTER //
// ./src/components/no-auth/account-exceptions.js